export const DURATION_SHORT_MOVIE = 40;
